// ────────────────────────────
// src/components/mainSection.jsx
// ────────────────────────────
import React from "react";
import mainBackground from "../assets/images/background/main_background.png";
// import whiteRoutinesIcon from "../assets/images/shapes/routines_icon_white.png";
// import whiteProgressIcon from "../assets/images/shapes/progress_icon_white.png";
// import whiteDietsIcon from "../assets/images/shapes/diets_icon_white.png";
import "./MainSection.css";
import PromoCTAButton from "./PromoCTAButton";

const APP_URL = process.env.REACT_APP_APP_URL || "https://app.zasfit.io";


export default function MainSection() {
  return (
    <section
      id="home"
      className="main-section bgs-cover rel z-2 pt-120 pb-180 rpb-20 text-center text-white"
      style={{ backgroundImage: `url(${mainBackground})` }}
    >
      <div className="container">

        <span className="sub-title wow fadeInUp delay-0-1s">
          Plataforma Fitness
        </span>
        
        {/* ——— 1ª línea ——— */}
        <h1 className="h1-eyebrow hero-label hero-label--white wow fadeInUp delay-0-2s">
          <span className="main-title-gradient-text">La Aplicación #1 para Entrenadores Personales</span>
        </h1>

        <h2 className="hero-hook wow fadeInUp delay-0-2s">
          <span className="gradient-text-main">Multiplica clientes,<br /> escala tu negocio</span>
        </h2>

        <p className="main-subtext mt-10 mb-10 wow fadeInUp delay-0-3s">
          Rutinas<span className="solo-desktop"> de entrenamiento personalizadas</span>, dietas <span className="solo-desktop">a medida</span> y seguimiento <span className="solo-desktop">del progreso </span>
          de tus clientes 
          <strong> en una aplicación para entrenadores personales todo-en-uno.</strong>
        </p>

        <div className="main-btns mt-30 mb-220 wow fadeInUp delay-0-4s d-flex justify-content-center gap-3">
          {/* “Empezar” = mismo layout que Dashboard + colores propios */}
          <a href={`${APP_URL}/auth/register`} className="theme-btn style-five btn-start btn-start-free-trial">
            Prueba Gratis 7 días
          </a>

          <PromoCTAButton />
          {/* <a href="#features" className="theme-btn style-five btn-info">
            Más Información
          </a> */}
        </div>
      </div>

      {/* <div className="section-alpha-text mb-225"></div> */}
      {/* <img className="routines-shape" src={whiteRoutinesIcon} alt="" /> */}
      {/* <img className="progress-shape" src={whiteProgressIcon} alt="" /> */}
      {/* <img className="diets-shape" src={whiteDietsIcon} alt="" /> */}
      <div className="left-circles" />
      <div className="right-circles" />
    </section>
  );
}
